import { Flex, Grid, Image } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EmptyCoach from "../../../../assets/images/content/empty_coach.png";
import { CoachResponse } from "../../../../hooks/Coach/data";
import { pushGtag } from "../../../../plugins/utils";
import { H6, P2 } from "../../../NormalFonts";
import styles from "./styleModule";

const CoachItem = ({ data }: { data: CoachResponse }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickCoach = (id: number) => {
    pushGtag({
      event: "view_coach",
      info: data,
    });

    navigate(`/trainers/info/${id}`);
  };

  const getNameSize = () => {
    if (screens.md) return "28px";
    if (screens.sm) return "20px";
    return "16px"; // Default for xs or smaller
  };
  const getImageMargin = () => {
    if (screens.md) return "20px";
    if (screens.sm) return "16px";
    return "8px"; // Default for xs or smaller
  };

  return (
    <div
      className={`${styles.coachItem} ${screens.md ? "" : styles.mobile}`}
      onClick={() => handleClickCoach(data.account_id)}
    >
      <Image
        width={"100%"}
        preview={false}
        src={data.profile_url}
        alt={data.nickname}
        className={styles.profile}
        fallback={EmptyCoach}
        style={{ marginBottom: getImageMargin() }}
      />
      <H6
        weight="heavy"
        color="var(--primary)"
        className={styles.nickname}
        style={{ fontSize: getNameSize() }}
      >
        {data.nickname}
      </H6>
      <Flex gap={8} justify="center">
        <P2
          className={styles.desc}
          weight="normal"
          color="var(--Neutral--dark-40)"
        >
          {data?.skill_codes && data?.skill_codes.length > 0
            ? data.skill_codes
                .map((skill: string) => t(`normal.skill.${skill}`))
                .join(" / ")
            : t("normal.empty")}
        </P2>
      </Flex>
    </div>
  );
};

export default CoachItem;
